// meetings-related actions

import MeetingConst from '../constants/meeting.constants';

export const MeetingAddTopic = item => ({
  type: MeetingConst.MEETING_ADD_TOPIC_NEW,
  value: item
});

export const MeetingNameUpdate = item => ({
  type: MeetingConst.MEETING_NAME_UPDATE,
  item
});

export const MeetingAddTopicItems = (item, defaultAttr) => ({
  type: MeetingConst.MEETING_ADD_TOPIC_ITEMS,
  value: item,
  defaultAttr
});

export const MeetingAddTakeAwayItems = item => ({
  type: MeetingConst.MEETING_ADD_TAKEAWAY_ITEM,
  value: item
});

export const MeetingAddTopicTakeAwayItems = (topicId, item) => ({
  type: MeetingConst.MEETING_ADD_TOPIC_TAKEAWAY_ITEM,
  topicId,
  item
});

export const MeetingAddTopicTag = (id, tagId, item) => ({
  type: MeetingConst.MEETING_ADD_TOPIC_TAG,
  id,
  tagId,
  item
});

export const MeetingAddNonTopicTag = (id, tagId, item) => ({
  type: MeetingConst.MEETING_ADD_NON_TOPIC_TAG,
  id,
  tagId,
  item
});

export const MeetingAddTakeTag = (id, tagId, topicId, item) => ({
  type: MeetingConst.MEETING_ADD_TAKE_TAG,
  id,
  tagId,
  topicId,
  item
});

export const MeetingUpdateTopic = (topicId, item) => ({
  type: MeetingConst.MEETING_TOPIC_UPDATE,
  topicId,
  item
});

export const MeetingUpdateNonTake = (topicId, item) => ({
  type: MeetingConst.MEETING_NON_TAKE_UPDATE,
  topicId,
  item
});

export const MeetingTopicTakeUpdate = (topicId, takeId, item) => ({
  type: MeetingConst.MEETING_TOPIC_TAKE_UPDATE,
  topicId,
  takeId,
  item
});

export const MeetingDelteTopic = (ids, item) => ({
  type: MeetingConst.MEETING_DELETE_TOPIC,
  ids,
  item
});

export const MeetingDeleteTopicTakeAway = (ids, topicId, item) => ({
  type: MeetingConst.MEETING_DELETE_TOPIC_TAKEAWAY,
  ids,
  topicId,
  item
});

export const MeetingDeleteNonTakeAway = (ids, item) => ({
  type: MeetingConst.MEETING_DELETE_NON_TOPIC_TAKEAWAY,
  ids,
  item
});

export const MeetingUpdatePaceValues = item => ({
  type: MeetingConst.MEETING_UPDATE_PACE_VALUES,
  value: item
});

export const MeetingUpdateTrends = item => ({
  type: MeetingConst.MEETING_UPDATE_TRENDS,
  value: item
});

export const MeetingUpdateTopicId = (tempAiId, newid, item) => ({
  type: MeetingConst.MEETING_UPDATE_TOPIC_ID,
  tempAiId,
  newid,
  item
});

export const MeetingUpdateNonTakeId = (tempAiId, newid, item) => ({
  type: MeetingConst.MEETING_UPDATE_NON_TAKEAWAY_ID,
  tempAiId,
  newId: newid,
  item
});

export const MeetingUpdateTopicTakeId = (
  tempAiId,
  topicRelId,
  newId,
  item
) => ({
  type: MeetingConst.MEETING_UPDATE_TOPIC_TAKE_ID,
  tempAiId,
  topicRelId,
  newId,
  item
});

export const MeetingUpdateShareTopic = (id, item) => ({
  type: MeetingConst.MEETING_SHARE_TOPIC,
  id,
  item
});

export const MeetingUpdateObject = (id, item) => ({
  type: MeetingConst.MEETING_UPDATE_OBJECT,
  id,
  item
});

export const MeetingChangePage = item => ({
  type: MeetingConst.MEETING_CHANGE_PAGE,
  item
});

export const MeetingUpdateTimerCounter = counter => ({
  type: MeetingConst.MEETING_UPDATE_TIMER_COUNTER,
  counter
});

export const MeetingUpdateInvitees = (id, item) => ({
  type: MeetingConst.MEETING_UPDATE_INVITEES,
  id,
  item
});

export const MeetingRemoveInvitee = item => ({
  type: MeetingConst.MEETING_REMOVE_INVITEE,
  item
});

export const MeetingUpdateInviteeAccess = item => ({
  type: MeetingConst.MEETING_UPDATE_INVITEE_ACCESS,
  item
});

export const MeetingUpdateUserTeamList = item => ({
  type: MeetingConst.MEETING_UPDATE_USER_TEAM,
  item
});

export const MeetingSyncData = item => ({
  type: MeetingConst.MEETING_SYNC_DATA,
  item
});

export const MeetingUpdateTimerStatus = (id, item) => ({
  type: MeetingConst.MEETING_UPDATE_TIMER_STATUS,
  id,
  item
});

export const MeetingUpdatePopupData = item => ({
  type: MeetingConst.MEETING_UPDATE_POPUP_DATA,
  item
});

export const MeetingUpdateSortData = (id, item) => ({
  type: MeetingConst.MEETING_SORT_ITEM,
  id,
  item
});

export const MeetingTakeUpdateSortData = (id, item) => ({
  type: MeetingConst.MEETING_SORT_TAKE_ITEM,
  id,
  item
});

export const MeetingTopicAttachDelete = (id, item) => ({
  type: MeetingConst.MEETING_DELETE_TOPIC_ATTACHMENT,
  id,
  item
});

export const MeetingNoteAttachDelete = (topicid, takeid, item) => ({
  type: MeetingConst.MEETING_DELETE_NOTE_ATTACHMENT,
  topicid,
  takeid,
  item
});

export const MeetingTopicAttachAdd = (id, item) => ({
  type: MeetingConst.MEETING_ADD_TOPIC_ATTACHMENT,
  id,
  item
});

export const MeetingNoteAttachAdd = (topicid, takeid, item) => ({
  type: MeetingConst.MEETING_ADD_NOTE_ATTACHMENT,
  topicid,
  takeid,
  item
});

export const UpdateMeetingS3Data = (objType, value) => ({
  type: MeetingConst.UPDATE_MEETING_S3DATA,
  objType,
  value
});

export const MeetingItemAddRemoveRecurring = (id, value) => ({
  type: MeetingConst.ADD_REMOVE_ITEM_RECURRING,
  id,
  value
});

export const MeetingAllItemAddRemoveRecurring = (meetingId, value) => ({
  type: MeetingConst.ADD_REMOVE_ALL_ITEM_RECURRING,
  meetingId,
  value
});

export const MeetingTopicToDiscuss = (id, value) => ({
  type: MeetingConst.MEETING_TOPIC_DISCUSS,
  id,
  value
});

export const MeetingsMinuteStateUpdate = state => ({
  type: MeetingConst.MEETING_SEND_MINUTES_UPDATE,
  state
});

export const MeetingWorkstreamNameUpdate = (id, name) => ({
  type: MeetingConst.MEETING_WS_UPDATE,
  id,
  name
});

export const MeetingAddNewTopicItems = item => ({
  type: MeetingConst.MEETING_NEW_TOPIC,
  value: item
});

export const updateTakeawaySmartWoboScore = (takeId, score) => ({
  type: MeetingConst.MEETING_UPDATE_TAKEAWAY_SMARTWOBO_SCORE,
  takeId,
  score
});

export const updateTakeawayShowSmartWobo = (takeId, showDialog) => ({
  type: MeetingConst.MEETING_UPDATE_TAKEAWAY_SHOW_SMARTWOBO,
  takeId,
  showDialog
});

export const markTakeawayIgnored = takeId => ({
  type: MeetingConst.MEETING_UPDATE_TAKEAWAY_IGNORE_SMARTWOBO,
  takeId
});

export const resetMeetingTakesForSmartWobo = resetValue => ({
  type: MeetingConst.MEETING_UPDATE_TAKEAWAYS_RESET_SMARTWOBO,
  resetValue
});

export const MeetingUpdateTopics = (topics) => ({
  type: MeetingConst.MEETING_UPDATE_TOPICS,
  value: topics
});

export const MeetingSetTakeSmartWoboId = (id = null) => ({
  type: MeetingConst.MEETING_SET_TAKE_SMART_WOBO_ID,
  payload: id
});

export const MeetingTopicAttachUpdate = (id, item) => ({
  type: MeetingConst.MEETING_UPDATE_TOPIC_ATTACHMENT,
  id,
  item
});

export const MeetingNoteAttachUpdate = (topicid, takeid, item) => ({
  type: MeetingConst.MEETING_UPDATE_NOTE_ATTACHMENT,
  topicid,
  takeid,
  item
});
